import { api } from './api';

export async function getNews(cad_missao: number, date?: any) {
  const payload = [
    {
      $match: {
        $or: [
          {
            cad_missao: cad_missao?.toString(),
          },
          {
            cad_missao: {
              $exists: false,
            },
          },
        ],
      },
    },
    { $sort: { created: -1 } },
    { $limit: 1 },
  ] as any;

  if (date) {
    payload.unshift({
      $match: {
        created: {
          $gt: {
            $date: date,
          },
        },
      },
    });
  }

  const { data } = await api.post(`find/get_news`, {date});
  if (!Array.isArray(data)) {
    return null;
  } else {
    return data[0];
  }
}
